import { render, staticRenderFns } from "./imgShow.vue?vue&type=template&id=0c55341b&scoped=true&"
import script from "./imgShow.vue?vue&type=script&lang=js&"
export * from "./imgShow.vue?vue&type=script&lang=js&"
import style0 from "./imgShow.vue?vue&type=style&index=0&id=0c55341b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c55341b",
  null
  
)

export default component.exports